import types from "../http_common";

/**
 * Global axios interceptor to handle authentication errors app-wide
 * Catches 401/403/token errors and prompts user to re-authenticate
 */

let authErrorCallback = null;

export const setAuthErrorCallback = (callback) => {
  authErrorCallback = callback;
};

export const setupAxiosInterceptors = () => {
  const apiInstance = types.json();
  
  /**
   * Response interceptor - catches errors from all API calls
   */
  apiInstance.interceptors.response.use(
    response => response,
    async error => {
      const status = error.response?.status;
      const message = error.response?.data?.message || error.message;
      const url = error.config?.url;
      
      // Check for authorization/permission errors (403 Forbidden)
      const isPermissionError = status === 403;
      
      // Check for authentication-related errors (401 Unauthorized or token issues)
      const isAuthError = 
        status === 401 ||  // Unauthorized
        message?.toLowerCase().includes('unauthorized') ||
        message?.toLowerCase().includes('token') ||
        message?.toLowerCase().includes('authenticated');
      
      if ((isAuthError || isPermissionError) && authErrorCallback) {
        const errorType = isPermissionError ? 'PERMISSION_DENIED' : 'AUTH_EXPIRED';
        
        console.error('[API Interceptor] Error detected:', {
          type: errorType,
          status,
          message,
          url,
          responseData: error.response?.data
        });
        
        // Trigger the global auth error callback with detailed error info
        authErrorCallback({
          status,
          message,
          url,
          type: errorType,
          isPermissionError,
          isAuthError,
          requiresSignIn: isAuthError,
          requiresPermission: isPermissionError,
          fullError: error.response?.data
        });
        
        // Prevent the error from propagating to individual handlers
        return Promise.reject({
          ...error,
          isAuthError: true,
          handled: true,
          type: errorType
        });
      }
      
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
